// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_SalvarAtributosLaudoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/salvar_atributos_laudo/{order_item_id}/{report_type}
 *
 * Returns the count of attribute values that were persisted for the report.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_SalvarAtributosLaudoResponseDados {
count: number
}

export type Orders_SalvarAtributosLaudoResponse = ApiResponse<Orders_SalvarAtributosLaudoResponseDados>;

registerResponseContract('Orders_SalvarAtributosLaudoResponse', {
  count: { type: 'number',  required: true },
})
